<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push({ path: '/productrecord/add', query: { productType } })">新增</el-button>
        <el-button type="primary" v-if="hasImport" @click="openImportDialog">导入</el-button>
        <el-button type="primary" v-if="hasExport" @click="onExport">导出</el-button>
        <el-button type="primary" v-if="hasGenerate" @click="openGenerate">批量生成生产绩效</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width"
               label-width="100px">
        <el-form-item v-if="!isRefining" label="所属客户" prop="userId">
          <el-select v-model="searchForm.userId" :clearable="true">
            <el-option :label="item.userName" :value="item.userId" v-for="item in userList"
                       :key="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配方" prop='productName'>
          <el-input clearable v-model="searchForm.productName" placeholder="配方"/>
        </el-form-item>
        <!-- ========== 新增搜索项 start ========== -->
        <el-form-item :label="isRefining ? '批号' : '编号'" prop="recordCode">
          <el-input clearable v-model="searchForm.recordCode" :placeholder="isRefining ? '批号' : '编号'"/>
        </el-form-item>
        <el-form-item v-if="!isRefining" label="原料品名" prop="rawMaterialName">
          <el-input clearable v-model="searchForm.rawMaterialName" placeholder="原料品名"/>
        </el-form-item>
        <el-form-item v-if="!isRefining" label="原料供应商" prop="rawMaterialSupplier">
          <el-input clearable v-model="searchForm.rawMaterialSupplier" placeholder="原料供应商"/>
        </el-form-item>
        <!-- ========== 新增搜索项 end ========== -->
        <!-- 当班日期按区间筛选，生产日期独立选择单个日期。 -->
        <el-form-item label="当班日期">
          <el-date-picker v-model="shiftDateRange" type="daterange" value-format="yyyy-MM-dd"
                          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="生产日期" prop="productionDate">
          <el-date-picker v-model="searchForm.productionDate" type="date" value-format="yyyy-MM-dd"
                          placeholder="请选择生产日期" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <template v-if="isRefining">
          <el-table-column min-width="160" show-overflow-tooltip label="当班日期" prop="shiftDate"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="生产编号" prop="byzdA2"><template v-slot="{ row }">{{ row.byzdA2 || row.recordId }}</template></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="生产日期" prop="productionDate"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="配方" prop="productName"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="生产线" prop="productionLine"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="原料罐" prop="rawMaterialTank"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="批号" prop="recordCode"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="当班人" prop="startupOperator"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="完成数量" prop="recordQuantity"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="入库罐" prop="inboundTank"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="入库名称" prop="inboundWarehouseName"></el-table-column>
        </template>
        <template v-else>
        <!-- 当班日期由接口返回，不从产品生产日期推算。 -->
        <el-table-column min-width="140" label="当班日期" prop="shiftDate"></el-table-column>
        <!-- 导入模板的生产编号保存在 byzdA2，与业务“编号”独立展示；手工记录回退到系统编号。 -->
        <el-table-column min-width="200" show-overflow-tooltip label="生产编号" prop="byzdA2">
          <template v-slot="{ row }">{{ row.byzdA2 || row.recordId }}</template>
        </el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="配方"
                         prop="productName"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="规格型号"
                         prop="specName"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="生产线"
                         prop="productionLine"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="原料罐"
                         prop="rawMaterialTank"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="开罐时间"
                         prop="tankOpeningTime"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="生产日期"
                         prop="productionDate"></el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="完成数量"
                         prop="recordQuantity"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="关联客户" prop="userName"></el-table-column>
        <!-- ========== 新增表格列 start ========== -->
        <el-table-column min-width="160" :show-overflow-tooltip="true" :label="isRefining ? '批号' : '编号'" prop="recordCode"></el-table-column>
        <el-table-column min-width="180" :show-overflow-tooltip="true" label="原料品名" prop="rawMaterialName"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="原料供应商" prop="rawMaterialSupplier"></el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="实际使用吨位" prop="actualUseTonnage"></el-table-column>
        <!--        <el-table-column min-width="220" :show-overflow-tooltip="true" label="储运液位吨位记录" prop="storageTransportLevelTonnageRecord"></el-table-column>-->
        <!--        <el-table-column min-width="160" :show-overflow-tooltip="true" label="剩余液位" prop="remainingLevel"></el-table-column>-->
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="开机时间" prop="startupTime"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="关机时间" prop="shutdownTime"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="开机人" prop="startupOperator"></el-table-column>
        <!-- ========== 新增表格列 end ========== -->

        </template>

        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <template>
              <el-button type="text"
                         @click="$router.push({ path: '/productrecord/detail', query: { recordId: row.recordId, productType } })">详情</el-button>
              <el-button type="text" v-if="hasDelete" @click="deleteRow(row.recordId)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>

    <el-dialog title="批量生成生产绩效" :visible.sync="generateVisible" width="560px" :close-on-click-modal="false" :show-close="!generating">
      <el-alert title="按查询条件生成全部匹配绩效，并按当班人（包装为开机人）自动分配。重复生成会更新自动分配，保留已手动分配的人员及金额；手动分配合计与新总绩效可能不同，可按需调整。" type="warning" :closable="false" />
      <el-form label-width="100px" class="mt15">
        <el-form-item label="查询范围"><div class="generation-scope">{{ generationScope }}</div></el-form-item>
        <el-form-item label="绩效系数"><el-input-number v-model="generateCoefficient" :min="0" :precision="3" :disabled="generating" /></el-form-item>
      </el-form>
      <div slot="footer"><el-button :disabled="generating" @click="generateVisible = false">取消</el-button><el-button type="primary" :loading="generating" @click="generatePerformance">确认生成并覆盖</el-button></div>
    </el-dialog>
    <el-dialog title="导入生产记录" :visible.sync="importDialogVisible" width="500px">
      <div class="import-wrap">
        <el-button type="text" icon="el-icon-download" @click="downloadTemplate">下载导入模板</el-button>
        <el-upload
          ref="uploadRef"
          class="mt15"
          accept=".xls,.xlsx"
          :auto-upload="false"
          :show-file-list="false"
          :file-list="importFileList"
          action=""
          :on-change="handleFileChange"
        >
          <el-button type="primary">导入</el-button>
        </el-upload>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import { exportFiles } from '@/utils/globalMethods'

export default {
  name: 'ProductRecord',
  mixins: [keepAlive],
  data() {
    return {
      userList: [],
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      // 仅接收最近一次列表请求，防止快速切换车间时旧响应覆盖新数据。
      listRequestId: 0,
      // 固定本次筛选快照，避免弹窗期间切换列表条件导致生成范围变化。
      generateVisible: false,
      generating: false,
      generateCoefficient: 1,
      generationFilters: {},
      // 当班日期区间，独立于产品生产日期。
      shiftDateRange: [],
      searchForm: {
        productName: '',
        // 产品生产日期，仅筛选选中当天。
        productionDate: '',
        userId: '',
        // 新增搜索表单字段
        recordCode: '',
        rawMaterialName: '',
        rawMaterialSupplier: ''
      },
      // 导入弹窗相关
      importDialogVisible: false,
      importLoading: false,
      importFileList: []
    }
  },
  created() {
    this.loadData()
    this.loadUserList()
  },
  computed: {
    isRefining() {
      return this.productType === '1'
    },
    productType() {
      return this.$route.query.productType
    },
    buttonList() {
      return this.$store.getters.getMenuByCode(this.menuCode)
    },
    menuCode() {
      return this.productType === '1' ? 'JLSCJL' : 'BZSCJL'
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasExport() {
      return this.buttonList.includes('export')
    },
    hasImport() {
      return this.buttonList.includes('import')
    },
    hasGenerate() {
      return this.buttonList.includes('generate')
    },
    // 分别展示当班日期区间和生产日期，便于确认批量生成范围。
    generationScope() {
      const filters = this.generationFilters
      const customer = this.userList.find(user => user.userId === filters.userId)
      return [filters.productType === '1' ? '精炼车间' : filters.productType === '2' ? '包装车间' : '全部车间',
        filters.shiftStartDate ? `当班日期：${filters.shiftStartDate} 至 ${filters.shiftEndDate}` : '全部当班日期',
        filters.productionDate ? `生产日期：${filters.productionDate}` : '全部生产日期',
        filters.userId ? `客户：${customer ? customer.userName : filters.userId}` : '',
        filters.productName ? `配方：${filters.productName}` : '',
        filters.recordCode ? `编号：${filters.recordCode}` : '',
        filters.rawMaterialName ? `原料：${filters.rawMaterialName}` : '',
        filters.rawMaterialSupplier ? `供应商：${filters.rawMaterialSupplier}` : ''].filter(Boolean).join('；')
    }
  },
  watch: {
    productType(val, oldVal) {
      if (val && val !== oldVal) {
        this.generateVisible = false
        this.tableData = []
        this.total = 0
        this.onReset()
      }
    }
  },
  methods: {
    // 查询、导出和批量生成统一读取当前日期控件，清空后不残留旧条件。
    buildSearchParams() {
      return {
        ...this.searchForm,
        ...(this.isRefining ? { userId: '', rawMaterialName: '', rawMaterialSupplier: '' } : {}),
        // 当班日期起止边界，空字符串表示不限制。
        shiftStartDate: (this.shiftDateRange || [])[0] || '',
        shiftEndDate: (this.shiftDateRange || [])[1] || '',
        productType: this.productType
      }
    },
    // 固定当前日期及其他筛选条件，供弹窗确认后批量生成。
    openGenerate() {
      this.generationFilters = this.buildSearchParams()
      this.generateVisible = true
    },
    async generatePerformance() {
      if (this.generating) return
      if (typeof this.generateCoefficient !== 'number' || !Number.isFinite(this.generateCoefficient) || this.generateCoefficient < 0) {
        return this.$message.warning('请输入不小于零的绩效系数')
      }
      this.generating = true
      try {
        const count = await this.$axios.post(this.$apis.productionPerformance.generate, {
          ...this.generationFilters,
          performanceCoefficient: this.generateCoefficient
        })
        this.generateVisible = false
        this.$message.success(`已生成或覆盖 ${count} 条生产产出绩效`)
      } finally {
        this.generating = false
      }
    },
    openImportDialog() {
      this.importDialogVisible = true
      this.importFileList = []
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles()
      }
    },
    // 直接下载指定的生产记录导入模板，避免将接口错误响应保存为模板文件。
    downloadTemplate() {
      if (this.isRefining) {
        const link = document.createElement('a')
        link.href = `${process.env.BASE_URL}templates/refining-import.xlsx`
        link.download = '精炼导入模板.xlsx'
        link.click()
        return
      }
      window.open('https://dcs.jscjly.com/group1/default/20261003/FAFC2C2A0C5546CEB2AA9C03B93969D3.xlsx?name=' + encodeURIComponent('生产记录导入模板.xlsx'), '_blank', 'noopener,noreferrer')
    },
    // 文件选中回调，选中后直接自动提交导入
    handleFileChange(file) {
      this.importFileList = [file]
      this.submitImport()
    },
    // 执行导入
    submitImport() {
      if (!this.importFileList.length) {
        return this.$message.warning('请先选择导入文件')
      }
      const file = this.importFileList[0].raw
      const formData = new FormData()
      formData.append('file', file)
      formData.append('productType', this.productType)

      this.importLoading = true
      this.$axios.post(this.$apis.prodManage.importScProRecord, formData).then(res => {
        this.$message.success('导入成功')
        this.importDialogVisible = false
        this.onSearch()
      }).finally(() => {
        this.importLoading = false
      })
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2,3,4'
      }).then(res => {
        this.userList = res.list
      })
    },
    // 使用当班日期区间及生产日期查询，仅接收最近一次请求结果。
    loadData() {
      const requestId = ++this.listRequestId
      this.loading = true
      return this.$axios.get(this.$apis.prodManage.selectScProRecordByPage, {
        page: this.page,
        size: 10,
        ...this.buildSearchParams()
      }).then(res => {
        if (requestId !== this.listRequestId) return
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        if (requestId === this.listRequestId) this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    // 同时清空当班日期区间和生产日期，并重置其他条件。
    onReset() {
      if (this.$refs.formData) this.$refs.formData.resetFields()
      this.shiftDateRange = []
      this.searchForm.productionDate = ''
      // 重置和车间切换都回到第一页，重新读取当前车间数据。
      this.onSearch()
    },
    // 导出全部匹配记录，与查询和批量生成使用相同日期条件。
    onExport() {
      exportFiles(this.$apis.prodManage.exportProductionRecord, this.buildSearchParams())
    },
    deleteRow(recordId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.prodManage.deleteScProRecord, {
          recordId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.import-wrap {
  padding: 10px 0;
}
</style>
